import {
  ID_ANCHOR,
  ID_AUDIO,
  ID_BODY,
  ID_BOLD,
  ID_BUTTON,
  ID_CANVAS,
  ID_DETAILS,
  ID_DIV,
  ID_FORM,
  ID_HEADER_1,
  ID_HEADER_2,
  ID_HEADER_3,
  ID_IMAGE,
  ID_LABEL,
  ID_PARAGRAPH,
  ID_SPAN,
  ID_SUMMARY,
  ID_SVG,
  ID_SVG_ANIMATE,
  ID_SVG_ANIMATE_MOTION,
  ID_SVG_ANIMATE_TRANSFORM,
  ID_SVG_CIRCLE,
  ID_SVG_CLIP_PATH,
  ID_SVG_DEFS,
  ID_SVG_ELLIPSE,
  ID_SVG_FILTER,
  ID_SVG_FILTER_EFFECT_BLEND,
  ID_SVG_FILTER_EFFECT_COLOR_MATRIX,
  ID_SVG_FILTER_EFFECT_COMPONENT_TRANSFER,
  ID_SVG_FILTER_EFFECT_CONVOLVE_MATRIX,
  ID_SVG_FILTER_EFFECT_DIFFUSE_LIGHTING,
  ID_SVG_FILTER_EFFECT_DISPLACEMENT_MAP,
  ID_SVG_FILTER_EFFECT_DISTANT_LIGHT,
  ID_SVG_FILTER_EFFECT_DROP_SHADOW,
  ID_SVG_FILTER_EFFECT_FLOOD,
  ID_SVG_FILTER_EFFECT_GAUSSIAN_BLUR,
  ID_SVG_FILTER_EFFECT_MERGE,
  ID_SVG_FILTER_EFFECT_MERGE_NODE,
  ID_SVG_FILTER_EFFECT_MORPHOLOGY,
  ID_SVG_FILTER_EFFECT_OFFSET,
  ID_SVG_FILTER_EFFECT_POINT_LIGHT,
  ID_SVG_FILTER_EFFECT_SPECULAR_LIGHTING,
  ID_SVG_FILTER_EFFECT_SPOT_LIGHT,
  ID_SVG_FILTER_EFFECT_TILE,
  ID_SVG_FILTER_EFFECT_TURBULENCE,
  ID_SVG_FOREIGN_OBJECT,
  ID_SVG_GROUP,
  ID_SVG_LINE,
  ID_SVG_LINEAR_GRADIENT,
  ID_SVG_MARKER,
  ID_SVG_MASK,
  ID_SVG_MPATH,
  ID_SVG_PATH,
  ID_SVG_PATTERN,
  ID_SVG_POLYGON,
  ID_SVG_POLYLINE,
  ID_SVG_RADIAL_GRADIENT,
  ID_SVG_RECT,
  ID_SVG_SET,
  ID_SVG_STOP,
  ID_SVG_SYMBOL,
  ID_SVG_TEXT,
  ID_SVG_TEXT_PATH,
  ID_SVG_TSPAN,
  ID_SVG_USE,
  ID_SVG_VIEW,
  ID_SWITCH,
  ID_TABLE,
  ID_TABLE_DATA,
  ID_TABLE_HEADER,
  ID_TABLE_ROW,
  ID_TEXT,
  ID_VIDEO,
} from '../system/_ids'

export const TAG_TO_SPEC_ID = {
  _text: ID_TEXT,
  body: ID_BODY,
  a: ID_ANCHOR,
  b: ID_BOLD,
  button: ID_BUTTON,
  canvas: ID_CANVAS,
  details: ID_DETAILS,
  div: ID_DIV,
  form: ID_FORM,
  h1: ID_HEADER_1,
  h2: ID_HEADER_2,
  h3: ID_HEADER_3,
  label: ID_LABEL,
  audio: ID_AUDIO,
  img: ID_IMAGE,
  video: ID_VIDEO,
  p: ID_PARAGRAPH,
  span: ID_SPAN,
  summary: ID_SUMMARY,
  table: ID_TABLE,
  td: ID_TABLE_DATA,
  th: ID_TABLE_HEADER,
  tr: ID_TABLE_ROW,
  animate: ID_SVG_ANIMATE,
  animateMotion: ID_SVG_ANIMATE_MOTION,
  animateTransform: ID_SVG_ANIMATE_TRANSFORM,
  circle: ID_SVG_CIRCLE,
  clipPath: ID_SVG_CLIP_PATH,
  defs: ID_SVG_DEFS,
  ellipse: ID_SVG_ELLIPSE,
  filter: ID_SVG_FILTER,
  feBlend: ID_SVG_FILTER_EFFECT_BLEND,
  feColorMatrix: ID_SVG_FILTER_EFFECT_COLOR_MATRIX,
  feComponentTransfer: ID_SVG_FILTER_EFFECT_COMPONENT_TRANSFER,
  feConvolveMatrix: ID_SVG_FILTER_EFFECT_CONVOLVE_MATRIX,
  feDiffuseLighting: ID_SVG_FILTER_EFFECT_DIFFUSE_LIGHTING,
  feDisplacementMap: ID_SVG_FILTER_EFFECT_DISPLACEMENT_MAP,
  feDistantLight: ID_SVG_FILTER_EFFECT_DISTANT_LIGHT,
  feDropShadow: ID_SVG_FILTER_EFFECT_DROP_SHADOW,
  feFlood: ID_SVG_FILTER_EFFECT_FLOOD,
  feGaussianBlur: ID_SVG_FILTER_EFFECT_GAUSSIAN_BLUR,
  feMerge: ID_SVG_FILTER_EFFECT_MERGE,
  feMergeNode: ID_SVG_FILTER_EFFECT_MERGE_NODE,
  feMorphology: ID_SVG_FILTER_EFFECT_MORPHOLOGY,
  feOffset: ID_SVG_FILTER_EFFECT_OFFSET,
  fePointLight: ID_SVG_FILTER_EFFECT_POINT_LIGHT,
  feSpecularLighting: ID_SVG_FILTER_EFFECT_SPECULAR_LIGHTING,
  feSpotLight: ID_SVG_FILTER_EFFECT_SPOT_LIGHT,
  feTile: ID_SVG_FILTER_EFFECT_TILE,
  feTurbulence: ID_SVG_FILTER_EFFECT_TURBULENCE,
  foreignObject: ID_SVG_FOREIGN_OBJECT,
  g: ID_SVG_GROUP,
  line: ID_SVG_LINE,
  linearGradient: ID_SVG_LINEAR_GRADIENT,
  marker: ID_SVG_MARKER,
  mask: ID_SVG_MASK,
  mpath: ID_SVG_MPATH,
  path: ID_SVG_PATH,
  pattern: ID_SVG_PATTERN,
  polygon: ID_SVG_POLYGON,
  polyline: ID_SVG_POLYLINE,
  radialGradient: ID_SVG_RADIAL_GRADIENT,
  image: ID_IMAGE,
  rect: ID_SVG_RECT,
  set: ID_SVG_SET,
  stop: ID_SVG_STOP,
  svg: ID_SVG,
  switch: ID_SWITCH,
  symbol: ID_SVG_SYMBOL,
  text: ID_SVG_TEXT,
  textPath: ID_SVG_TEXT_PATH,
  tspan: ID_SVG_TSPAN,
  use: ID_SVG_USE,
  view: ID_SVG_VIEW,
}
